import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { createQueryClient } from "./lib/query";
import { AuthProvider } from "./lib/auth";
import { SkinProvider } from "./lib/skin";
import { App } from "./App";
import { WurzelFehlergrenze } from "./ui/Fehlergrenze";
import "./styles/app.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

const queryClient = createQueryClient();

createRoot(container).render(
  <StrictMode>
    <WurzelFehlergrenze>
      <QueryClientProvider client={queryClient}>
        <SkinProvider>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </SkinProvider>
      </QueryClientProvider>
    </WurzelFehlergrenze>
  </StrictMode>,
);
